module.exports = __webpack_public_path__ + "static/media/pin_event.c5d01277.svg";